import lightLogo from '../lightthemelogo.png';
import darkLogo from '../darkthemelogo.png';
import { useTheme } from '../context/ThemeContext';
import './BrandWordmark.css';

export default function BrandWordmark({ className = '', compact = false, lightOnDark = false, forceLightLogo = false }) {
  const { theme } = useTheme();
  const usesDarkLogo = !forceLightLogo && (lightOnDark || theme === 'dark');
  const classes = [
    'brand-wordmark',
    compact ? 'brand-wordmark-compact' : '',
    lightOnDark ? 'brand-wordmark-light-on-dark' : '',
    usesDarkLogo ? 'brand-wordmark-dark-logo' : '',
    className,
  ].filter(Boolean).join(' ');
  const logo = usesDarkLogo ? darkLogo : lightLogo;

  return (
    <span className={classes} aria-label="NiceBooster">
      <img className="brand-wordmark-image" src={logo} alt="NiceBooster" />
    </span>
  );
}
